// extracted by mini-css-extract-plugin
export default {"form":"Settings_form__LBZRN","total":"Settings_total__GdMMb","overall":"Settings_overall__5AhyP","checkboxes":"Settings_checkboxes__1pVZ5","buttons":"Settings_buttons__SC4hg"};